import { useState, useEffect } from 'react';
import { getCoupons, createCoupon, updateCoupon, deleteCoupon } from '../services/api';

const empty = { code: '', discount_type: 'percentage', discount_value: 10, max_discount: '', min_order: 0, category: '', total_limit: 100, per_user_limit: 1, valid_from: '', valid_to: '', is_active: true };

export default function Coupons() {
  const [coupons, setCoupons] = useState([]);
  const [form, setForm] = useState({ ...empty });
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(true);

  const load = async () => { setLoading(true); try { setCoupons(await getCoupons()); } catch (_) {} setLoading(false); };
  useEffect(() => { load(); }, []);

  const handleSave = async () => {
    const payload = {
      ...form,
      discount_value: parseFloat(form.discount_value) || 0,
      max_discount: form.max_discount ? parseFloat(form.max_discount) : null,
      min_order: parseFloat(form.min_order) || 0,
      total_limit: parseInt(form.total_limit) || 100,
      per_user_limit: parseInt(form.per_user_limit) || 1,
      category: form.category || null,
      valid_from: form.valid_from || null,
      valid_to: form.valid_to || null,
    };
    try {
      if (editId) await updateCoupon(editId, payload);
      else await createCoupon(payload);
      setShowForm(false); setEditId(null); setForm({ ...empty }); load();
    } catch (e) { alert(e.response?.data?.detail || 'Failed'); }
  };

  const handleEdit = (c) => {
    setForm({
      code: c.code, discount_type: c.discount_type, discount_value: c.discount_value,
      max_discount: c.max_discount || '', min_order: c.min_order || 0, category: c.category || '',
      total_limit: c.total_limit, per_user_limit: c.per_user_limit,
      valid_from: c.valid_from ? c.valid_from.substring(0, 16) : '',
      valid_to: c.valid_to ? c.valid_to.substring(0, 16) : '',
      is_active: c.is_active,
    });
    setEditId(c.id); setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this coupon?')) return;
    try { await deleteCoupon(id); load(); } catch (e) { alert('Failed'); }
  };

  const handleToggle = async (c) => {
    try { await updateCoupon(c.id, { is_active: !c.is_active }); load(); } catch (_) {}
  };

  return (
    <div className="page">
      <div className="page-header">
        <h1>🎟️ Coupons</h1>
        <p>Create and manage discount coupons</p>
      </div>

      <div style={{ marginBottom: 16 }}>
        <button className="btn btn-primary" onClick={() => { setShowForm(!showForm); setEditId(null); setForm({ ...empty }); }}>
          {showForm ? '✗ Close' : '➕ Create Coupon'}
        </button>
      </div>

      {showForm && (
        <div className="card" style={{ marginBottom: 24, padding: 20 }}>
          <h3>{editId ? '✏️ Edit Coupon' : '➕ New Coupon'}</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginTop: 12 }}>
            <div>
              <label>Code</label>
              <input value={form.code} onChange={e => setForm({ ...form, code: e.target.value.toUpperCase() })}
                placeholder="AC25" style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 8 }} disabled={!!editId} />
            </div>
            <div>
              <label>Type</label>
              <select value={form.discount_type} onChange={e => setForm({ ...form, discount_type: e.target.value })}
                style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 8 }}>
                <option value="percentage">Percentage (%)</option>
                <option value="flat">Flat (₹)</option>
              </select>
            </div>
            <div>
              <label>Discount Value</label>
              <input type="number" value={form.discount_value} onChange={e => setForm({ ...form, discount_value: e.target.value })}
                placeholder="25" style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 8 }} />
            </div>
            <div>
              <label>Max Discount (₹) <small style={{color:'#999'}}>cap</small></label>
              <input type="number" value={form.max_discount} onChange={e => setForm({ ...form, max_discount: e.target.value })}
                placeholder="Auto-capped by commission" style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 8 }} />
            </div>
            <div>
              <label>Min Order (₹)</label>
              <input type="number" value={form.min_order} onChange={e => setForm({ ...form, min_order: e.target.value })}
                placeholder="499" style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 8 }} />
            </div>
            <div>
              <label>Category <small style={{color:'#999'}}>blank=all</small></label>
              <input value={form.category} onChange={e => setForm({ ...form, category: e.target.value })}
                placeholder="AC, Plumbing..." style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 8 }} />
            </div>
            <div>
              <label>Total Limit</label>
              <input type="number" value={form.total_limit} onChange={e => setForm({ ...form, total_limit: e.target.value })}
                style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 8 }} />
            </div>
            <div>
              <label>Per User Limit</label>
              <input type="number" value={form.per_user_limit} onChange={e => setForm({ ...form, per_user_limit: e.target.value })}
                style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 8 }} />
            </div>
            <div>
              <label>Valid From</label>
              <input type="datetime-local" value={form.valid_from} onChange={e => setForm({ ...form, valid_from: e.target.value })}
                style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 8 }} />
            </div>
            <div>
              <label>Valid To</label>
              <input type="datetime-local" value={form.valid_to} onChange={e => setForm({ ...form, valid_to: e.target.value })}
                style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 8 }} />
            </div>
            <div style={{ display: 'flex', alignItems: 'end' }}>
              <button className="btn btn-success" onClick={handleSave}>{editId ? '💾 Update' : '✅ Create'}</button>
            </div>
          </div>
          <p style={{ marginTop: 12, fontSize: 12, color: '#666' }}>
            ⚠️ Auto-protection: Discount will never exceed your commission (20%) on any order. You never lose money.
          </p>
        </div>
      )}

      {loading ? <p>Loading...</p> : (
        <div className="card">
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Discount</th>
                  <th>Max Cap</th>
                  <th>Min Order</th>
                  <th>Category</th>
                  <th>Used / Limit</th>
                  <th>Per User</th>
                  <th>Valid</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {coupons.map(c => (
                  <tr key={c.id}>
                    <td><strong>{c.code}</strong></td>
                    <td>{c.discount_type === 'percentage' ? `${c.discount_value}%` : `₹${c.discount_value}`}</td>
                    <td>{c.max_discount ? `₹${c.max_discount}` : 'Auto'}</td>
                    <td>₹{c.min_order}</td>
                    <td>{c.category || 'All'}</td>
                    <td>{c.total_used} / {c.total_limit}</td>
                    <td>{c.per_user_limit}</td>
                    <td style={{ fontSize: 11 }}>
                      {c.valid_from ? c.valid_from.substring(0, 10) : '—'} → {c.valid_to ? c.valid_to.substring(0, 10) : '—'}
                    </td>
                    <td>
                      <span className={`badge ${c.is_active ? 'badge-success' : 'badge-danger'}`}>
                        {c.is_active ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: 4 }}>
                        <button className="btn btn-sm btn-warning" onClick={() => handleEdit(c)}>✏️</button>
                        <button className={`btn btn-sm ${c.is_active ? 'btn-danger' : 'btn-success'}`} onClick={() => handleToggle(c)}>
                          {c.is_active ? '🚫' : '✅'}
                        </button>
                        <button className="btn btn-sm" style={{ background: '#666', color: '#fff' }} onClick={() => handleDelete(c.id)}>🗑️</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
